<template>
    <div class="about-section bg-off-white pt-100 pb-70 bg-linear-gradient">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 pb-30">
                    <div class="about-section-item about-item-image text-center">
                        <img class="product-img" v-lazy="$ossImg(localizedImg('product/two/1.png'))" alt="shape">
                    </div>
                </div>
                <div class="col-lg-6 pb-30 flex-right">
                    <div class="about-section-item about-item-details width585">
                        <div class="section-title section-title-left text-start">
                            <h2 class="font48">{{ $t('products.two.about.title') }}</h2>
                        </div>
                        <div class="about-content">
                            <p class="font20">{{ $t('products.two.about.description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import localizedImageMixin from '@/mixins/localizedImageMixin'

export default {
    name: 'About',
    mixins: [localizedImageMixin]
}
</script>
<style scoped>
.bg-linear-gradient {
    background: linear-gradient(137deg, #FCF5FF 3.23%, #F2F9FE 83.93%);
}

.main-btn {
    background: linear-gradient(90deg, #0B71FA 0%, #29ABFD 100%);
    transition: all 0.5s ease-in-out;
}

.main-btn:hover {
    background: linear-gradient(90deg, #0B71FA 0%, #FF94C8 100%);
}
</style>
